<template>
  <!-- 查看已选转交抽屉 -->
  <Drawer
    :width="400"
    :closable="true"
    :scrollable="false"
    :lock-scroll="true"
    v-model="visible"
    :styles="{
      padding: '0 0 48px 16px',
      display: 'flex',
      'flex-direction': 'column',
      overflow: 'hidden'
    }"
    @on-cancel="onCancel"
  >
    <p slot="header">
      {{ $t('approval.selectedApproval').replace('$1', selectedCount) }}
    </p>
    <ul class="selected-list-box">
      <li class="selected-item" v-for="(item, index) in values" :key="item.id">
        <Row type="flex" align="middle" :gutter="16">
          <Col>
            <Checkbox
              :value="item.checked"
              @on-change="onChange($event, index)"
            />
          </Col>
          <Col>
            <Row align="middle" type="flex">
              <Avatar
                :size="28"
                :src="item.employee.avatar"
                :style="
                  item.employee.avatar ? '' : 'background: rgb(186, 217, 255)'
                "
                circle
              >
                {{ $substrName(item.employee.displayName) }}
              </Avatar>
              <span class="selected-item-name">
                {{ item.employee.displayName }}
              </span>
            </Row>
            <p class="selected-item-title">
              {{ item.title }}
              <span class="selected-item-id">({{ item.id }})</span>
            </p>
            <p>
              {{ $moment(`${item.createdAt}Z`).format('YYYY-MM-DD HH:mm') }}
            </p>
          </Col>
        </Row>
      </li>
    </ul>
    <Row
      class="selected-footer"
      type="flex"
      align="middle"
      justify="end"
      :gutter="10"
    >
      <Col>
        <Button @click="onCancel">
          {{ $t('btn.cancel') }}
        </Button>
      </Col>
      <Col>
        <Button
          type="primary"
          ghost
          :disabled="values.length === 0"
          @click="onClear"
        >
          {{ $t('btn.clear') }}
        </Button>
      </Col>
      <Col>
        <Button type="primary" @click="onSave">
          {{ $t('global.text23') }}
        </Button>
      </Col>
    </Row>
  </Drawer>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      values: []
    };
  },
  computed: {
    // 统计已选择审批数量
    selectedCount() {
      let num = 0;
      _.forEach(this.values, (v) => {
        if (v.checked) {
          num++;
        }
      });
      return num;
    }
  },
  methods: {
    show(values) {
      this.visible = true;
      this.values = _.cloneDeep(values);
    },
    // 查看已选复选框事件
    onChange(e, i) {
      const item = this.values[i];
      item.checked = e;
      this.values.splice(i, 1, item);
    },
    // 关闭查看已选
    onCancel() {
      this.visible = false;
      this.values = [];
    },
    // 清空已选择数据
    onClear() {
      this.values = [];
    },
    // 修改已选择数据
    onSave() {
      const arr = _.filter(this.values, (v) => v.checked);
      this.$emit('on-change', _.cloneDeep(arr));
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.selected-list-box {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}

.selected-list-box,
.selected-item {
  list-style: none;
}

.selected-item {
  padding: 10px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #efecec;
  }
}

.selected-item-name {
  margin-left: 8px;
  font-weight: bold;
}

.selected-item-title {
  margin: 10px 0;
}

.selected-item-id {
  color: #909090;
}

.selected-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 48px;
  border-top: 1px solid #efecec;
}
</style>
